import { normalizeId } from './ids';

const normalizePathSegment = (value) => {
  const normalized = normalizeId(value);

  if (normalized === '[object Object]') return '';

  return normalized;
};
const getMatchManagerScope = ({ organizationId, communityId, clubId, individualTournamentId }) => {
  if (communityId) {
    return { type: 'community', id: normalizePathSegment(communityId) };
  }

  if (clubId) {
    return { type: 'club', id: normalizePathSegment(clubId) };
  }

  if (organizationId) {
    return { type: 'org', id: normalizePathSegment(organizationId) };
  }

  if (individualTournamentId) {
    return { type: 'individual-tournament', id: normalizePathSegment(individualTournamentId) };
  }

  return { type: '', id: '' };
};

const buildMatchManagerBasePath = ({ organizationId, communityId, clubId, individualTournamentId, managerId }) => {
  const scope = getMatchManagerScope({ organizationId, communityId, clubId, individualTournamentId });
  const normalizedManagerId = normalizePathSegment(managerId);

  if (!scope.type || !scope.id || !normalizedManagerId) return '';

  if (scope.type === 'individual-tournament') {
    return `/individual-tournament/${scope.id}/match-manager/${normalizedManagerId}`;
  }

  return `/${scope.type}/${scope.id}/match-manager/${normalizedManagerId}`;
};

export const buildMatchManagerTournamentsPath = ({
  organizationId,
  communityId,
  clubId,
  managerId,
  individualTournamentId,
}) => {
  const basePath = buildMatchManagerBasePath({
    organizationId,
    communityId,
    clubId,
    managerId,
    individualTournamentId,
  });

  return basePath ? `${basePath}/tournaments` : '';
};


export const buildMatchManagerTournamentPath = ({
  organizationId,
  communityId,
  clubId,
  managerId,
  tournamentId,
  individualTournamentId,
}) => {
  const tournamentsPath = buildMatchManagerTournamentsPath({
    organizationId,
    communityId,
    clubId,
    managerId,
    individualTournamentId,
  });
  const normalizedTournamentId = normalizePathSegment(tournamentId);

  if (!tournamentsPath || !normalizedTournamentId) return '';

  return `${tournamentsPath}/${normalizedTournamentId}`;
};

export const buildMatchManagerMatchesPath = ({
  organizationId,
  communityId,
  clubId,
  managerId,
  tournamentId,
  individualTournamentId,
}) => {
  const tournamentPath = buildMatchManagerTournamentPath({
    organizationId,
    communityId,
    clubId,
    managerId,
    tournamentId,
    individualTournamentId,
  });

  return tournamentPath ? `${tournamentPath}/matches` : '';
};

export const buildMatchManagerMatchPath = ({
  organizationId,
  communityId,
  clubId,
  managerId,
  tournamentId,
  individualTournamentId,
  matchId,
}) => {
  const matchesPath = buildMatchManagerMatchesPath({
    organizationId,
    communityId,
    clubId,
    managerId,
    tournamentId,
    individualTournamentId,
  });
  const normalizedMatchId = normalizePathSegment(matchId);

  if (!matchesPath || !normalizedMatchId) return '';

  return `${matchesPath}/${normalizedMatchId}`;
};

export const buildMatchManagerMatchStartPath = (params) => {
  const matchPath = buildMatchManagerMatchPath(params);

  return matchPath ? `${matchPath}/start` : '';
};

export const buildMatchManagerMatchTossPath = (params) => {
  const startPath = buildMatchManagerMatchStartPath(params);

  return startPath ? `${startPath}?view=toss` : '';
};

export const buildMatchManagerFormatsPath = ({
  organizationId,
  communityId,
  clubId,
  managerId,
  tournamentId,
  individualTournamentId,
}) => {
  const basePath = buildMatchManagerBasePath({
    organizationId,
    communityId,
    clubId,
    managerId,
    individualTournamentId,
  });
  const normalizedTournamentId = normalizePathSegment(tournamentId);

  if (!basePath || !normalizedTournamentId) return '';

  return `${basePath}/tournaments/${normalizedTournamentId}/match-formats`;
};

export const buildMatchManagerManualFormatPath = ({
  organizationId,
  communityId,
  clubId,
  managerId,
  tournamentId,
  individualTournamentId,
}) => {
  const formatsPath = buildMatchManagerFormatsPath({
    organizationId,
    communityId,
    clubId,
    managerId,
    tournamentId,
    individualTournamentId,
  });

  return formatsPath ? `${formatsPath}/manual` : '';
};
